import { BarChart } from 'lucide-react';

const LoadingBarChart = () => (
    <div className="flex items-center justify-center animate-pulse">
        <BarChart className="w-8 h-8 text-gray-400 rotate-90" />
    </div>
);

export default LoadingBarChart;
